import styled from "styled-components";

export const StyledPageIntro = styled.div`
  padding: ${(props) => props.padding || "10px 18px 0"};
  margin: ${(props) => props.margin || "0"};

  h1 {
    margin: 10px 0 0;
    color: var(--rms-v2-text-title);
    font-size: 20px;
    font-weight: 900;
    letter-spacing: 0;
  }

  p {
    margin: 10px 0 0;
    color: var(--rms-v2-text-muted);
    font-size: 14px;
    font-weight: 400;
  }
`;
